import React from 'react';
import {
    Card, CardHeader, CardBody, CardFooter,
    CardLink, CardText,
    Modal, ModalBody, ModalFooter,
    Button
} from 'reactstrap';

import FileDownload from "components/Varios/FileDownload.js";

export default class CardExperienciaProyectos extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
        };
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen,
        });
    };

    onClick = change => {
        this.setState(
            {
                isOpen: !this.state.isOpen,
            },
            (() => { this.props.eventDelete() })
        );
    };

    parseDate(date) {
        if (date) {
            date = new Date(date)
            return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
        }
        return null
    }

    render() {

        return (
            <div className="col-md-4 col-xs-4" style={{ paddingBottom: "15px" }}>
                <Card>
                    <CardBody>
                        <CardText>
                            <b>{this.props.objeto.nombre}</b>
                            <br />
                            <br />
                            <span className="spanCard">TIPO DE PROYECTO: </span>{this.props.objeto.strTipo}
                            <br />
                            <span className="spanCard">TIPO DE INVESTIGACIÓN: </span>{this.props.objeto.strSubtipo}
                            {this.props.objeto.institucionEspol ? <>
                            <br />
                                <span className="spanCard">INSTITUCIÓN DENTRO DE ESPOL: </span>{this.props.objeto.institucionEspol} </> : null
                            }
                            {this.props.objeto.institucionExterna ? <>
                            <br />
                                <span className="spanCard">INSTITUCIÓN EXTERNA: </span>{this.props.objeto.institucionExterna} </> : null
                            }
                            <br />
                            <span className="spanCard">ESTADO DEL PROYECTO: </span>{this.props.objeto.estadoproyecto}
                            <br />
                            <span className="spanCard">FECHA INICIO: </span>{this.parseDate(this.props.objeto.fechainicio)}
                            <br />
                            <span className="spanCard">FECHA FIN: </span>{this.parseDate(this.props.objeto.fechafin)}
                            <br />
                            <br />
                            <span className="spanCard">CINE: </span>
                            {this.props.objeto.strAreacampoamplio}
                            <br />
                            <span className="spanCard">FRASCATI: </span>
                            {this.props.objeto.strAreafrascati}
                            <br />
                            {
                                this.props.objeto.strAreacampoamplio2 ?
                                    <>
                                        <br />
                                        <span className="spanCard">CINE 2: </span>
                                        {this.props.objeto.strAreacampoamplio2}
                                    </>
                                    :
                                    null
                            }
                            {
                                this.props.objeto.strAreafrascati2 ?
                                    <>
                                        <br />
                                        <span className="spanCard">FRASCATI 2: </span>
                                        {this.props.objeto.strAreafrascati2}
                                    </>
                                    :
                                    null
                            }
                        </CardText>
                    </CardBody>
                    <CardFooter className="text-muted">
                        <div style={{ float: "left" }}>
                            {this.props.number}
                        </div>
                        <div style={{ float: "right" }}>
                            <FileDownload files={this.props.evidencias} card={true} icon="download" />
                        </div>
                    </CardFooter>
                </Card>
            </div>
        )

    }
}